import { createFileRoute } from '@tanstack/react-router';
import { StudentDashboardPage } from '@pages/student';

/**
 * Student My Courses Page
 *
 * Route: /:locale/student/my_courses
 */
export const Route = createFileRoute('/$locale/_authenticated/student/my_courses')({
  component: StudentMyCourses,
});

function StudentMyCourses() {
  return <StudentDashboardPage />;
}
